/*
 * Project: bellcloud
 * File: packages/protocols/mini/fn_configuration.ts
 * Author: SWAN
 * Created: 2025-01-27
 * Description: ClassID.CONFIGURATION (0x03)에 대한 FunctionID별 파라미터 정의
 */
import type { FunctionParameter } from '../fns';

export const params_configuration: Record<number, FunctionParameter[]> = {
  0x01: [],
  0x02: [
    {
      name: 'stealth_mode',
      type: 'u8',
      bytes: 1,
      comment: '0: off(default), 1: on - DISABLED: 항상 off(0)로 설정됨 (2025-12-03)',
      format: 'bool',
    },
    {
      name: 'safe_mode',
      type: 'u8',
      bytes: 1,
      comment: '0: off(default), 1: on - DISABLED: 항상 off(0)로 설정됨 (2025-12-03)',
      format: 'bool',
    },
    {
      name: 'latching_alarm',
      type: 'u8',
      bytes: 1,
      comment: '0: disabled, 1: enabled',
      format: 'bool',
    },
    {
      name: 'low_alarm_ack',
      type: 'u8',
      bytes: 1,
      comment: '0: disabled, 1: enabled',
      format: 'bool',
    },
    {
      name: 'confidence_beep',
      type: 'u8',
      bytes: 1,
      comment: '0: disabled, 1: enabled',
      format: 'bool',
    },
    {
      name: 'green_light',
      type: 'u8',
      bytes: 1,
      comment: '0: disabled, 1: enabled',
      format: 'bool',
    },
    {
      name: 'confidence_interval',
      type: 'u16',
      bytes: 2,
      comment: '1~60(sec)',
      format: 'number',
    },
    {
      name: 'intelliflash_interval',
      type: 'u16',
      bytes: 2,
      comment: '1~60(sec)',
      format: 'number',
    },
    {
      name: 'datalog_interval',
      type: 'u16',
      bytes: 2,
      comment: '1~60(sec)',
      format: 'number',
    },
    {
      name: 'worker_name',
      type: 'au8[]',
      bytes: 20,
      comment: 'Worker name',
      format: 'string',
    },
    {
      name: 'location_name',
      type: 'au8[]',
      bytes: 20,
      comment: 'Location name',
      format: 'string',
    },
    {
      name: 'timestamp',
      type: 'u32',
      bytes: 4,
      comment: 'seconds since 2023.01.01',
      format: 'date_seconds_from_basedate',
    },
    {
      name: 'calibration_gas_conc',
      type: 's32',
      bytes: 4,
      comment: '0~9999 conc.',
      format: 'gas_concentration',
    },
    {
      name: 'calibration_interval',
      type: 's32',
      bytes: 4,
      comment: '0~365(days)',
      format: 'number',
    },
    {
      name: 'bump_interval',
      type: 's32',
      bytes: 4,
      comment: '0~365(days)',
      format: 'number',
    },
    {
      name: 'low_alarm',
      type: 's32',
      bytes: 4,
      comment: '0~9999 conc. (O2: 0~30 conc.)',
      format: 'gas_concentration',
    },
    {
      name: 'high_alarm',
      type: 's32',
      bytes: 4,
      comment: '0~9999 conc. (O2: 0~30 conc.)',
      format: 'gas_concentration',
    },
    {
      name: 'twa_alarm',
      type: 's32',
      bytes: 4,
      comment: '0~9999 conc.',
      format: 'gas_concentration',
    },
    {
      name: 'stel_alarm',
      type: 's32',
      bytes: 4,
      comment: '0~9999 conc.',
      format: 'gas_concentration',
    },
    {
      name: 'stel_period',
      type: 'u16',
      bytes: 2,
      comment: '5~15 minutes, default: 15',
      format: 'number',
    },
    {
      name: 'auto_fresh_air_cal',
      type: 'u8',
      bytes: 1,
      comment: '0: off(default), 1: on - DISABLED: 항상 off(0)로 설정됨 (2025-12-03)',
      format: 'bool',
    },
    {
      name: 'set_date_time',
      type: 'u8',
      bytes: 1,
      comment: 'Reserved, ignore',
      format: 'bool',
    },
    {
      name: 'twa_period',
      type: 'u8',
      bytes: 1,
      comment: '4~8 hours, default: 8',
      format: 'number',
    },
  ],
  0x03: [
    {
      name: 'stealth_mode',
      type: 'u8',
      bytes: 1,
      comment: '0: off(default), 1: on - DISABLED: 항상 off(0)로 설정됨 (2025-12-03)',
      format: 'bool',
    },
    {
      name: 'safe_mode',
      type: 'u8',
      bytes: 1,
      comment: '0: off(default), 1: on - DISABLED: 항상 off(0)로 설정됨 (2025-12-03)',
      format: 'bool',
    },
    {
      name: 'latching_alarm',
      type: 'u8',
      bytes: 1,
      comment: '0: disabled, 1: enabled',
      format: 'bool',
    },
    {
      name: 'low_alarm_ack',
      type: 'u8',
      bytes: 1,
      comment: '0: disabled, 1: enabled',
      format: 'bool',
    },
    {
      name: 'confidence_beep',
      type: 'u8',
      bytes: 1,
      comment: '0: disabled, 1: enabled',
      format: 'bool',
    },
    {
      name: 'green_light',
      type: 'u8',
      bytes: 1,
      comment: '0: disabled, 1: enabled',
      format: 'bool',
    },
    {
      name: 'confidence_interval',
      type: 'u16',
      bytes: 2,
      comment: '1~60(sec)',
      format: 'number',
    },
    {
      name: 'intelliflash_interval',
      type: 'u16',
      bytes: 2,
      comment: '1~60(sec)',
      format: 'number',
    },
    {
      name: 'datalog_interval',
      type: 'u16',
      bytes: 2,
      comment: '1~60(sec)',
      format: 'number',
    },
    {
      name: 'worker_name',
      type: 'au8[]',
      bytes: 20,
      comment: 'Worker name',
      format: 'string',
    },
    {
      name: 'location_name',
      type: 'au8[]',
      bytes: 20,
      comment: 'Location name',
      format: 'string',
    },
    {
      name: 'timestamp',
      type: 'u32',
      bytes: 4,
      comment: 'Seconds since 2023.01.01',
      format: 'date_seconds_from_basedate',
    },
    {
      name: 'calibration_gas_conc',
      type: 's32',
      bytes: 4,
      comment: '0~9999 conc.',
      format: 'gas_concentration',
    },
    {
      name: 'calibration_interval',
      type: 's32',
      bytes: 4,
      comment: '0~365(days)',
      format: 'number',
    },
    {
      name: 'bump_interval',
      type: 's32',
      bytes: 4,
      comment: '0~365(days)',
      format: 'number',
    },
    {
      name: 'low_alarm',
      type: 's32',
      bytes: 4,
      comment: '0~9999 conc. (O2: 0~30 conc.)',
      format: 'gas_concentration',
    },
    {
      name: 'high_alarm',
      type: 's32',
      bytes: 4,
      comment: '0~9999 conc. (O2: 0~30 conc.)',
      format: 'gas_concentration',
    },
    {
      name: 'twa_alarm',
      type: 's32',
      bytes: 4,
      comment: '0~9999 conc.',
      format: 'gas_concentration',
    },
    {
      name: 'stel_alarm',
      type: 's32',
      bytes: 4,
      comment: '0~9999 conc.',
      format: 'gas_concentration',
    },
    {
      name: 'stel_period',
      type: 'u16',
      bytes: 2,
      comment: '5~15 minutes, default: 15',
      format: 'number',
    },
    {
      name: 'auto_fresh_air_cal',
      type: 'u8',
      bytes: 1,
      comment: '0: off(default), 1: on - DISABLED: 항상 off(0)로 설정됨 (2025-12-03)',
      format: 'bool',
    },
    {
      name: 'set_date_time',
      type: 'u8',
      bytes: 1,
      comment: '0: Not set date/time, 1: Set date/time to RTC',
      format: 'bool',
    },
    {
      name: 'twa_period',
      type: 'u8',
      bytes: 1,
      comment: '4~8 hours, default: 8',
      format: 'number',
    },
  ],
  0x04: [], // Response set configuration - no parameters
};
